import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

/**
 * Public OAuth `redirect_uri` for shareable Google Ads connection links.
 * Google sends the external Ads owner here after consent; the page forwards
 * the query string to integration-service's callback, which verifies `state`,
 * exchanges the code and redirects to `/connector/:token/select` or `/done`.
 * Lives outside `_authenticated`: the owner has no platform login.
 */
const ConnectorOAuthCallbackPage = lazy(
  () => import('~/features/connector-share/pages/connector-oauth-callback-page'),
);

export const Route = createFileRoute('/public/oauth/google-ads/callback')({
  component: () => (
    <Suspense fallback={null}>
      <ConnectorOAuthCallbackPage />
    </Suspense>
  ),
});
